module.exports = __webpack_public_path__ + "img/Rust-2.0b9c053a.png";